module.exports = __webpack_public_path__ + "static/media/QR.0bc298ae.png";